/**
 * `seq` for the console's assist envelopes (contract §3 lists it as required;
 * every other console sender stamps one). One counter for this page load; the
 * console's only assist send is now `assist_answer`.
 */
let assistSeq = 0;

export const nextAssistSeq = () => {
  assistSeq += 1;
  return assistSeq;
};
